export default (state, { id }) => state.customers.data && id && state.customers.data[id]
